import { Component, OnInit } from '@angular/core';
import { signOut } from 'aws-amplify/auth';
import { AdminService } from '@shared/services/admin.service';
import { environment } from '@environments/environment';
import { ServiceRequestService } from '@shared/services/service-request.service';
import {
  ROUTES_Frontliner,
  ROUTES_FrontlinerCBMRating,
  ROUTES_FrontlinerConfiguredNoBothCSRandReport,
  ROUTES_FrontlinerConfiguredNoBothCSRandReportNoRating,
  ROUTES_FrontlinerConfiguredNoCSR,
  ROUTES_FrontlinerConfiguredNoCSRNoRating,
  ROUTES_FrontlinerConfiguredNoReport,
  ROUTES_FrontlinerConfiguredNoReportNoRating,
  ROUTES_FrontlinerNormalCBMRating,
  ROUTES_SystemAdministrator,
  ROUTES_SystemAdministratorCBMRating,
  ROUTES_SystemAdministratorConfig,
  ROUTES_SystemAdministratorConfigAndCBMRating,
} from './sidebar.constants';

@Component({
    // moduleId: module.id,
    selector: 'sidebar-cmp',
    templateUrl: 'sidebar.component.html',
    standalone: false
})
export class SidebarComponent implements OnInit {
  isDefault = true;

  hasFCreateSR = true;
  hasFReports = true;

  userScreenName: string;
  userType: string;
  profileUserType: string;

  dropShow: boolean = false;
  dropShow2: boolean = false;

  ctr = 0;
  hasUser = true;
  hasConfig = true;

  isAdmin = 1;
  constructor(
    private adminService: AdminService,
    private _requestService: ServiceRequestService
  ) {}

  img_src =
    'https://pngimage.net/wp-content/uploads/2019/05/user-female-png-1.png';

  public menuItems: any[];
  ngOnInit() {
    this.profileUserType = localStorage.getItem('userType');
    let userEmail = localStorage.getItem('userEmail');
    this.getRoutingDetails(userEmail);
  }

  getRoutingDetails(email) {
    this.adminService
      .getUserProfileInfoByID(localStorage.getItem('userProfileTag'))
      .subscribe(resp => {
        console.log('RESP LOGIN CHOICES = ', resp);
        let currProfile = localStorage.getItem('userProfileTag');

        this.adminService.getUser(email).subscribe(profile => {
          console.log('DATA 3 = ', profile);

          if (profile['body']['teamLeader'] == true) {
            localStorage.setItem('isTeamLeader', 'true');
          } else {
            localStorage.setItem('isTeamLeader', 'false');
          }

          localStorage.setItem(
            'userScreenName',
            profile['body']['firstName'] + ' ' + profile['body']['lastName']
          );
          this.userScreenName =
            profile['body']['firstName'] + ' ' + profile['body']['lastName'];
          //DEFAULT ADMIN AND FRONTLINER
          if (
            this.profileUserType == 'SystemAdministrator' &&
            currProfile == '0'
          ) {
            this.isAdmin = 1;
            this.isDefault = true;
            console.log('LOGIN! ', profile['body']);
            localStorage.setItem('createSR', 'false');
            localStorage.setItem('editSR', 'false');
            localStorage.setItem('viewSR', 'true');

            localStorage.setItem('createCBM', 'true');
            localStorage.setItem('editCBM', 'true');
            localStorage.setItem('viewCBM', 'true');

            localStorage.setItem('createUM', 'true');
            localStorage.setItem('editUM', 'true');
            localStorage.setItem('viewUM', 'true');

            localStorage.setItem('createReports', 'true');

            if (profile['body']['permissions']['grant_edit'] == '1') {
              this.menuItems = ROUTES_SystemAdministratorCBMRating.filter(
                menuItem => menuItem
              );
              localStorage.setItem('adminCBMRating', '1');
            } else {
              this.menuItems = ROUTES_SystemAdministrator.filter(
                menuItem => menuItem
              );
              localStorage.setItem('adminCBMRating', '0');
            }

            this.userType = 'Administrator';
          } else if (
            (this.profileUserType == 'CustomerCareRepresentative' ||
              this.profileUserType == 'BIZPartnerManager') &&
            (currProfile == '0' ||
              currProfile == environment.defaultUserProfileID)
          ) {
            localStorage.setItem('frontliner_id', profile['body']['id']);
            this.isAdmin = 0;
            this.isDefault = true;

            localStorage.setItem('createSR', 'true');
            localStorage.setItem('editSR', 'true');
            localStorage.setItem('viewSR', 'true');

            localStorage.setItem('createCBM', 'false');
            localStorage.setItem('editCBM', 'false');
            localStorage.setItem('viewCBM', 'false');

            localStorage.setItem('createUM', 'false');
            localStorage.setItem('editUM', 'false');
            localStorage.setItem('viewUM', 'false');

            localStorage.setItem('createReports', 'true');

            if (profile['body']['permissions']['grant_edit'] == '1') {
              this.menuItems = ROUTES_FrontlinerCBMRating.filter(
                menuItem => menuItem
              );
              localStorage.setItem('frontCBMRating', '1');
            } else {
              this.menuItems = ROUTES_Frontliner.filter(menuItem => menuItem);
              localStorage.setItem('frontCBMRating', '0');
            }

            //this.menuItems = ROUTES_Frontliner.filter(menuItem => menuItem);

            this.userType = this.profileUserType
              .replace(/([A-Z])/g, ' $1')
              .trim()
              .replace('B I Z', 'BIZ');
          }

          //CONFIGURED ADMIN AND FRONTLINER
          if (
            this.profileUserType == 'SystemAdministrator' &&
            currProfile != '0'
          ) {
            this.isAdmin = 1;
            this.isDefault = false;

            console.log('LOGIN! ', profile['body']);

            for (let ctr = 0; ctr < resp['body']['permissions'].length; ctr++) {
              //Service Requests
              if (
                resp['body']['permissions'][ctr]['access_rights_id'] ==
                '88e12849-91f2-4a14-bf25-aeba48f90ddf'
              ) {
                if (resp['body']['permissions'][ctr]['grant_create'] == 1) {
                  localStorage.setItem('createSR', 'true');
                } else {
                  localStorage.setItem('createSR', 'false');
                }

                if (resp['body']['permissions'][ctr]['grant_edit'] == 1) {
                  localStorage.setItem('editSR', 'true');
                } else {
                  localStorage.setItem('editSR', 'false');
                }

                if (resp['body']['permissions'][ctr]['grant_view'] == 1) {
                  localStorage.setItem('viewSR', 'true');
                } else {
                  localStorage.setItem('viewSR', 'false');
                }
              }

              //CBM MGMT
              if (
                resp['body']['permissions'][ctr]['access_rights_id'] ==
                '0b488624-76ba-4108-ac50-e828a8a6a97c'
              ) {
                if (resp['body']['permissions'][ctr]['grant_create'] == 1) {
                  localStorage.setItem('createCBM', 'true');
                } else {
                  localStorage.setItem('createCBM', 'false');
                }

                if (resp['body']['permissions'][ctr]['grant_edit'] == 1) {
                  localStorage.setItem('editCBM', 'true');
                } else {
                  localStorage.setItem('editCBM', 'false');
                }

                if (resp['body']['permissions'][ctr]['grant_view'] == 1) {
                  localStorage.setItem('viewCBM', 'true');
                } else {
                  localStorage.setItem('viewCBM', 'false');
                }
              }

              //USER MGMT
              if (
                resp['body']['permissions'][ctr]['access_rights_id'] ==
                '6257f967-eee8-4345-826a-610095b4df8f'
              ) {
                if (resp['body']['permissions'][ctr]['grant_create'] == 1) {
                  localStorage.setItem('createUM', 'true');
                } else {
                  localStorage.setItem('createUM', 'false');
                }

                if (resp['body']['permissions'][ctr]['grant_edit'] == 1) {
                  localStorage.setItem('editUM', 'true');
                } else {
                  localStorage.setItem('editUM', 'false');
                }

                if (resp['body']['permissions'][ctr]['grant_view'] == 1) {
                  localStorage.setItem('viewUM', 'true');
                } else {
                  localStorage.setItem('viewUM', 'false');
                }
              }

              //OVERALL REPORT

              if (
                resp['body']['permissions'][ctr]['access_rights_id'] ==
                '00b63ef8-3233-458c-a86b-af52a8601f26'
              ) {
                if (resp['body']['permissions'][ctr]['grant_create'] == 1) {
                  localStorage.setItem('createReports', 'true');
                } else {
                  localStorage.setItem('createReports', 'false');
                }
              }

              //EDIT CBM TECH RATING
              if (
                resp['body']['permissions'][ctr]['access_rights_id'] ==
                '4956f5aa-6af6-4e2c-80df-aed85e020883'
              ) {
                if (resp['body']['permissions'][ctr]['grant_edit'] == 1) {
                  localStorage.setItem('adminCBMRating', '1');
                  if (localStorage.getItem('createReports') == 'true') {
                    this.menuItems = ROUTES_SystemAdministratorCBMRating.filter(
                      menuItem => menuItem
                    );
                  } else {
                    this.menuItems = ROUTES_SystemAdministratorConfigAndCBMRating.filter(
                      menuItem => menuItem
                    );
                  }
                } else if (
                  resp['body']['permissions'][ctr]['grant_edit'] == 0
                ) {
                  localStorage.setItem('adminCBMRating', '0');
                  if (localStorage.getItem('createReports') == 'true') {
                    this.menuItems = this.menuItems = ROUTES_SystemAdministrator.filter(
                      menuItem => menuItem
                    );
                  } else {
                    this.menuItems = this.menuItems = ROUTES_SystemAdministratorConfig.filter(
                      menuItem => menuItem
                    );
                  }
                }
              }
            }

            /*if(profile['body']['permissions']['grant_edit'] == '1')
                        {
                            if(localStorage.getItem('createReports') == 'true')
                            {
                                this.menuItems = ROUTES_SystemAdministratorCBMRating.filter(menuItem => menuItem);
                                localStorage.setItem('adminCBMRating', '1');
                            }
                            else
                            {
                                this.menuItems = ROUTES_SystemAdministratorConfigAndCBMRating.filter(menuItem => menuItem);
                                localStorage.setItem('adminCBMRating', '1');
                            }
                        }
                        else
                        {
                            if(localStorage.getItem('createReports') == 'true')
                            {
                                this.menuItems = ROUTES_SystemAdministrator.filter(menuItem => menuItem);
                                localStorage.setItem('adminCBMRating', '0');
                            }
                            else
                            {
                                this.menuItems = ROUTES_SystemAdministratorConfig.filter(menuItem => menuItem);
                                localStorage.setItem('adminCBMRating', '0');
                            }

                        }*/

            this.userType = 'Administrator';
          } else if (
            (this.profileUserType == 'CustomerCareRepresentative' ||
              this.profileUserType == 'BIZPartnerManager') &&
            currProfile != environment.defaultUserProfileID &&
            currProfile != '0'
          ) {
            localStorage.setItem('frontliner_id', profile['body']['id']);
            this.isAdmin = 0;
            this.isDefault = false;

            let hasReportFront = 0;

            for (let ctr = 0; ctr < resp['body']['permissions'].length; ctr++) {
              //Service Requests
              if (
                resp['body']['permissions'][ctr]['access_rights_id'] ==
                '88e12849-91f2-4a14-bf25-aeba48f90ddf'
              ) {
                if (resp['body']['permissions'][ctr]['grant_create'] == 1) {
                  console.log(
                    'TRY HERE = ',
                    resp['body']['permissions'][ctr]['grant_create']
                  );
                  this.hasFCreateSR = true;
                  localStorage.setItem('createSR', 'true');
                } else {
                  this.hasFCreateSR = false;
                  localStorage.setItem('createSR', 'false');
                }

                if (resp['body']['permissions'][ctr]['grant_edit'] == 1) {
                  localStorage.setItem('editSR', 'true');
                } else {
                  localStorage.setItem('editSR', 'false');
                }

                if (resp['body']['permissions'][ctr]['grant_view'] == 1) {
                  localStorage.setItem('viewSR', 'true');
                } else {
                  localStorage.setItem('viewSR', 'false');
                }
              }

              //SR REPORT
              if (
                resp['body']['permissions'][ctr]['access_rights_id'] ==
                '073d940c-9d94-4e8f-936d-d387fe6ec493'
              ) {
                if (resp['body']['permissions'][ctr]['grant_create'] == 1) {
                  this.hasFReports = true;
                  localStorage.setItem('createReports', 'true');
                } else {
                  this.hasFReports = false;
                  localStorage.setItem('createReports', 'false');
                }
              }

              //EDIT CBM TECH RATING
              if (
                resp['body']['permissions'][ctr]['access_rights_id'] ==
                '4956f5aa-6af6-4e2c-80df-aed85e020883'
              ) {
                if (resp['body']['permissions'][ctr]['grant_edit'] == 1) {
                  localStorage.setItem('frontCBMRating', '1');
                } else if (
                  resp['body']['permissions'][ctr]['grant_edit'] == 0
                ) {
                  localStorage.setItem('frontCBMRating', '0');
                }
              }
            }

            if (
              localStorage.getItem('createSR') == 'true' &&
              localStorage.getItem('createReports') == 'true'
            ) {
              console.log('FILTER - both ok');
              if (localStorage.getItem('frontCBMRating') == '0') {
                this.menuItems = ROUTES_Frontliner.filter(menuItem => menuItem);
              } else {
                this.menuItems = ROUTES_FrontlinerNormalCBMRating.filter(
                  menuItem => menuItem
                );
              }
            } else if (
              localStorage.getItem('createSR') == 'true' &&
              localStorage.getItem('createReports') == 'false'
            ) {
              console.log('FILTER - no report');
              if (localStorage.getItem('frontCBMRating') == '0') {
                this.menuItems = ROUTES_FrontlinerConfiguredNoReportNoRating.filter(
                  menuItem => menuItem
                );
              } else {
                this.menuItems = ROUTES_FrontlinerConfiguredNoReport.filter(
                  menuItem => menuItem
                );
              }
            } else if (
              localStorage.getItem('createSR') == 'false' &&
              localStorage.getItem('createReports') == 'true'
            ) {
              console.log('FILTER - no sr');
              if (localStorage.getItem('frontCBMRating') == '0') {
                this.menuItems = ROUTES_FrontlinerConfiguredNoCSRNoRating.filter(
                  menuItem => menuItem
                );
              } else {
                this.menuItems = ROUTES_FrontlinerConfiguredNoCSR.filter(
                  menuItem => menuItem
                );
              }
            } else {
              console.log('FILTER - no both');
              if (localStorage.getItem('frontCBMRating') == '0') {
                this.menuItems = ROUTES_FrontlinerConfiguredNoBothCSRandReportNoRating.filter(
                  menuItem => menuItem
                );
              } else {
                this.menuItems = ROUTES_FrontlinerConfiguredNoBothCSRandReport.filter(
                  menuItem => menuItem
                );
              }
            }
            this.userType = this.profileUserType
              .replace(/([A-Z])/g, ' $1')
              .trim()
              .replace('B I Z', 'BIZ');
          }
        });
      });
  }

  //FOR CHANGE FONT OF SUBMENU WHEN CLICKED
  onChangeClass(myelement: any, myclassName: string) {
    //console.log("BAM ELEMENT ", myelement)
    let elemName: string = 'menuChild' + String(myelement);
    // console.log("BAM ELEMENT 2 =", elemName);

    if (elemName == 'menuChild0') {
      document.getElementById(elemName).className = 'menuChildren2';
      document.getElementById('menuChild1').className = 'menuChildren';
    } else if (elemName == 'menuChild1') {
      document.getElementById(elemName).className = 'menuChildren2';
      document.getElementById('menuChild0').className = 'menuChildren';
    }
  }

  //FOR HOVER HIGHLIGHT
  onHover(myelement) {
    //HOVER ICONS
    if (this.isAdmin == 1) {
      console.log('HOVER ON =', myelement.target.id);
      var selItem = myelement.target.id;
      if (localStorage.getItem('adminCBMRating') == '0') {
        if (selItem == 'mainItem0') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon0');
          subIcon.src =
            '../../../../assets/img/icons/CBMSidenavIcons/SVG/SR_Hover.svg';
        }
        if (selItem == 'mainItem1') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon1');
          subIcon.src =
            '../../../../assets/img/icons/CBMSidenavIcons/SVG/CBM_Hover.svg';
        } else if (selItem == 'mainItem2') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon2');
          subIcon.src =
            '../../../../assets/img/icons/CBMSidenavIcons/SVG/User_Hover.svg';

          var subIcon2 = <HTMLImageElement>document.getElementById('subIcon0');
          subIcon2.src =
            '../../../../assets/img/icons/SidenavArrows/SVG/Sidenav_Hover.svg';
        } else if (selItem == 'mainItem3') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon3');
          subIcon.src = '../../../../assets/img/report_hover.svg';
        } else if (selItem == 'mainItem4') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon4');
          subIcon.src =
            '../../../../assets/img/icons/CBMSidenavIcons/SVG/Config_Hover.svg';

          var subIcon2 = <HTMLImageElement>document.getElementById('subIcon1');
          subIcon2.src =
            '../../../../assets/img/icons/SidenavArrows/SVG/Sidenav_Hover.svg';
        }
        /*else if(selItem == "mainItem5")
                {
                    var subIcon = <HTMLImageElement>document.getElementById('mainIcon5');
                    subIcon.src = '../../../../assets/img/resetPass_hover.svg';
                
                }*/
      } else if (localStorage.getItem('adminCBMRating') == '1') {
        if (selItem == 'mainItem0') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon0');
          subIcon.src =
            '../../../../assets/img/icons/CBMSidenavIcons/SVG/SR_Hover.svg';
        }
        if (selItem == 'mainItem1') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon1');
          subIcon.src =
            '../../../../assets/img/icons/CBMSidenavIcons/SVG/CBM_Hover.svg';
        } else if (selItem == 'mainItem2') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon2');
          subIcon.src =
            '../../../../assets/img/icons/CBMSidenavIcons/SVG/CBM_Hover.svg';
          //subIcon.src = '../../../../assets/img/icons/new_icons/Mask Group 8.svg'
          //'../../../../assets/img/icons/CBMSidenavIcons/SVG/User_Hover.svg';

          var subIcon2 = <HTMLImageElement>document.getElementById('subIcon0');
          subIcon2.src =
            '../../../../assets/img/icons/SidenavArrows/SVG/Sidenav_Hover.svg';
        } else if (selItem == 'mainItem3') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon3');
          subIcon.src =
            '../../../../assets/img/icons/CBMSidenavIcons/SVG/User_Hover.svg'; //'../../../../assets/img/report_hover.svg';
        } else if (selItem == 'mainItem4') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon4');
          subIcon.src = '../../../../assets/img/reports_hover.svg';
          //'../../../../assets/img/icons/CBMSidenavIcons/SVG/Config_Hover.svg';

          //var subIcon2 = <HTMLImageElement>document.getElementById('subIcon1');
          //subIcon2.src = '../../../../assets/img/icons/SidenavArrows/SVG/Sidenav_Hover.svg';
        }
        /*else if(selItem == "mainItem5")
                {
                    var subIcon = <HTMLImageElement>document.getElementById('mainIcon5');
                    subIcon.src = '../../../../assets/img/resetPass_hover.svg';
                
                }*/
      }
    } else if (this.isAdmin == 0) {
      console.log('HOVER ON =', myelement.target.id);
      var selItem = myelement.target.id;
      if (localStorage.getItem('frontCBMRating') == '0') {
        if (selItem == 'mainItem0') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon0');
          subIcon.src =
            '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/SR_hover.svg';
        }
        if (selItem == 'mainItem1') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon1');
          subIcon.src =
            '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/transaction_hover.svg';
        } else if (selItem == 'mainItem2') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon2');
          subIcon.src = '../../../../assets/img/reports_hover.svg';
        } else if (selItem == 'mainItem3') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon3');
          subIcon.src =
            '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/history_hover.svg';
        }
        /*else if(selItem == "mainItem4")
                {
                    var subIcon = <HTMLImageElement>document.getElementById('mainIcon4');
                    subIcon.src = '../../../../assets/img/icons/CBMSidenavIcons/SVG/CBM_Hover.svg';
                    //'../../../../assets/img/resetPass_hover.svg';
                }*/
      } else if (localStorage.getItem('frontCBMRating') == '1') {
        if (selItem == 'mainItem0') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon0');
          subIcon.src =
            '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/SR_hover.svg';
        }
        if (selItem == 'mainItem1') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon1');
          subIcon.src =
            '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/transaction_hover.svg';
        } else if (selItem == 'mainItem2') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon2');
          subIcon.src = '../../../../assets/img/reports_hover.svg';
        } else if (selItem == 'mainItem3') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon3');
          subIcon.src =
            '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/history_hover.svg';
        } else if (selItem == 'mainItem4') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon4');
          subIcon.src =
            '../../../../assets/img/icons/CBMSidenavIcons/SVG/CBM_Hover.svg';
          //'../../../../assets/img/resetPass_hover.svg';
        }
      }
    }
  }

  //HOVER NORMAL
  offHover(myelement) {
    //HOVER ICONS
    if (this.isAdmin == 1) {
      if (localStorage.getItem('adminCBMRating') == '0') {
        console.log('HOVER OFF =', myelement.target.id);
        var selItem = myelement.target.id;
        if (selItem == 'mainItem0') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon0');
          subIcon.src =
            '../../../../assets/img/icons/CBMSidenavIcons/SVG/SR_Default.svg';
        }
        if (selItem == 'mainItem1') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon1');
          subIcon.src =
            '../../../../assets/img/icons/CBMSidenavIcons/SVG/CBM_Default.svg';
        } else if (selItem == 'mainItem2') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon2');
          subIcon.src =
            '../../../../assets/img/icons/CBMSidenavIcons/SVG/User_Default.svg';

          var subIcon2 = <HTMLImageElement>document.getElementById('subIcon0');
          subIcon2.src =
            '../../../../assets/img/icons/SidenavArrows/SVG/Sidenav_Default.svg';
        } else if (selItem == 'mainItem3') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon3');
          subIcon.src =
            '../../../../assets/img/icons/CBMSidenavIcons/SVG/Report_Default.svg';
        } else if (selItem == 'mainItem4') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon4');
          subIcon.src =
            '../../../../assets/img/icons/CBMSidenavIcons/SVG/Config_Default.svg';

          var subIcon2 = <HTMLImageElement>document.getElementById('subIcon1');
          subIcon2.src =
            '../../../../assets/img/icons/SidenavArrows/SVG/Sidenav_Default.svg';
        }
        /*if(selItem == "mainItem5")
            {
                var subIcon = <HTMLImageElement>document.getElementById('mainIcon5');
                subIcon.src = '../../../../assets/img/resetPass_default.svg';
            }*/
      } else if (localStorage.getItem('adminCBMRating') == '1') {
        console.log('HOVER OFF =', myelement.target.id);
        var selItem = myelement.target.id;
        if (selItem == 'mainItem0') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon0');
          subIcon.src =
            '../../../../assets/img/icons/CBMSidenavIcons/SVG/SR_Default.svg';
        }
        if (selItem == 'mainItem1') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon1');
          subIcon.src =
            '../../../../assets/img/icons/CBMSidenavIcons/SVG/CBM_Default.svg';
        } else if (selItem == 'mainItem2') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon2');
          subIcon.src =
            '../../../../assets/img/icons/CBMSidenavIcons/SVG/CBM_Default.svg';
          //'../../../../assets/img/icons/new_icons/Mask Group 8.svg'
          //'../../../../assets/img/icons/CBMSidenavIcons/SVG/User_Default.svg';

          var subIcon2 = <HTMLImageElement>document.getElementById('subIcon0');
          subIcon2.src =
            '../../../../assets/img/icons/SidenavArrows/SVG/Sidenav_Default.svg';
        } else if (selItem == 'mainItem3') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon3');
          subIcon.src =
            '../../../../assets/img/icons/CBMSidenavIcons/SVG/User_Default.svg';

          //'../../../../assets/img/icons/CBMSidenavIcons/SVG/Report_Default.svg';
        } else if (selItem == 'mainItem4') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon4');
          subIcon.src = '../../../../assets/img/reports_default.svg';
          //'../../../../assets/img/icons/CBMSidenavIcons/SVG/Config_Default.svg';

          //var subIcon2 = <HTMLImageElement>document.getElementById('subIcon1');
          //subIcon2.src = '../../../../assets/img/icons/SidenavArrows/SVG/Sidenav_Default.svg';
        }
        /*if(selItem == "mainItem5")
            {
                var subIcon = <HTMLImageElement>document.getElementById('mainIcon5');
                subIcon.src = '../../../../assets/img/resetPass_default.svg';
            }*/
      }
    } else if (this.isAdmin == 0) {
      console.log('HOVER OFF =', myelement.target.id);
      var selItem = myelement.target.id;

      if (localStorage.getItem('frontCBMRating') == '0') {
        if (selItem == 'mainItem0') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon0');
          subIcon.src =
            '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/SR_default.svg';
        }
        if (selItem == 'mainItem1') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon1');
          subIcon.src =
            '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/transaction_default.svg';
        } else if (selItem == 'mainItem2') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon2');
          subIcon.src = '../../../../assets/img/reports_default.svg';
        } else if (selItem == 'mainItem3') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon3');
          subIcon.src =
            '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/history_default.svg';
        }

        /*if(selItem == "mainItem4")
                {
                    var subIcon = <HTMLImageElement>document.getElementById('mainIcon4');
                    subIcon.src = '../../../../assets/img/resetPass_default.svg';
                }*/
      } else if (localStorage.getItem('frontCBMRating') == '1') {
        if (selItem == 'mainItem0') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon0');
          subIcon.src =
            '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/SR_default.svg';
        }
        if (selItem == 'mainItem1') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon1');
          subIcon.src =
            '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/transaction_default.svg';
        } else if (selItem == 'mainItem2') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon2');
          subIcon.src = '../../../../assets/img/reports_default.svg';
        } else if (selItem == 'mainItem3') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon3');
          subIcon.src =
            '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/history_default.svg';
        }

        if (selItem == 'mainItem4') {
          var subIcon = <HTMLImageElement>document.getElementById('mainIcon4');
          subIcon.src =
            '../../../../assets/img/icons/CBMSidenavIcons/SVG/CBM_Hover.svg';

          //'../../../../assets/img/resetPass_default.svg';
        }
      }
    }
  }

  //FOR ARROW UP DOWN ANIMATION ON CLICK OF MENU ITEMS WITH SUBMENUS
  /* onChangeSubIcon(myelement : string)
    {
        //console.log("BAM UP ICON", myelement)
        
        //TOGGLE ARROW
        
        if(this.isAdmin == 1)
        {
            if(localStorage.getItem('adminCBMRating') == '0')
            {
                if(myelement == "subIcon" && this.ctr == 0)
                {
                    this.ctr += 1
                    var subIcon = <HTMLImageElement>document.getElementById('subIcon0');
                    subIcon.src = '../../../../assets/img/icons/SidenavArrows/SVG/Sidenav_Active.svg';
                }
                else if(myelement == "subIcon" && this.ctr == 1)
                {
                    this.ctr -= 1
                    var subIcon = <HTMLImageElement>document.getElementById('subIcon0');
                    subIcon.src = '../../../../assets/img/icons/SidenavArrows/SVG/Sidenav_Default.svg';
        
                }
            }
            else  if(localStorage.getItem('adminCBMRating') == '1')
            {
                if(myelement.includes("subIcon") && this.ctr == 0)
                {
                    this.ctr += 1
                    var subIcon = <HTMLImageElement>document.getElementById(myelement);
                    subIcon.src = '../../../../assets/img/icons/SidenavArrows/SVG/Sidenav_Active.svg';
                }
                else if(myelement.includes("subIcon") && this.ctr == 1)
                {
                    this.ctr = 0
                    var subIcon = <HTMLImageElement>document.getElementById(myelement);
                    subIcon.src = '../../../../assets/img/icons/SidenavArrows/SVG/Sidenav_Default.svg';
        
                }
            } 
            
        } 
        

        /*if(myelement == "subIcon1" && this.ctr == 0)
        {
            this.ctr += 1
            var subIcon = <HTMLImageElement>document.getElementById('subIcon1');
            subIcon.src = '../../../../assets/img/icons/SidenavArrows/SVG/Sidenav_Active.svg';
        }
        else if(myelement == "subIcon1" && this.ctr == 1)
        {
            this.ctr -= 1
            var subIcon = <HTMLImageElement>document.getElementById('subIcon1');
            subIcon.src = '../../../../assets/img/icons/SidenavArrows/SVG/Sidenav_Default.svg';

        }

    }*/

  /*onClickChangePass()
    {
      window.location.replace(environment.changePass_home);
    }*/

  async onClickLogout() {
    await signOut();
    localStorage.clear();
    // window.location.replace(environment.signIn);
  }

  dropClick(menuTitle: string, subArrow: string): void {
    if (this.isAdmin == 1) {
      var arrow = <HTMLImageElement>document.getElementById(subArrow);

      if (menuTitle == 'user management') {
        this.dropShow = !this.dropShow;
        this.dropShow2 = false;

        this.dropShow
          ? (arrow.src =
              '../../../../assets/img/icons/SidenavArrows/SVG/Sidenav_Active.svg')
          : (arrow.src =
              '../../../../assets/img/icons/SidenavArrows/SVG/Sidenav_Default.svg');
      }

      if (menuTitle == 'Configure Settings') {
        this.dropShow2 = !this.dropShow2;
        this.dropShow = false;

        this.dropShow2
          ? (arrow.src =
              '../../../../assets/img/icons/SidenavArrows/SVG/Sidenav_Active.svg')
          : (arrow.src =
              '../../../../assets/img/icons/SidenavArrows/SVG/Sidenav_Default.svg');
      }

      var arrowElements = <HTMLCollection>(
        document.getElementsByClassName('sidebar-icon-sub')
      );
      for (let i = 0; i < arrowElements.length; i++) {
        if (arrowElements[i].id != subArrow) {
          var otherArrow = <HTMLImageElement>(
            document.getElementById(arrowElements[i].id)
          );
          otherArrow.src =
            '../../../../assets/img/icons/SidenavArrows/SVG/Sidenav_Default.svg';
        }
      }
    } else {
      if (menuTitle == 'Create Service Request') {
        var subIcon = <HTMLImageElement>document.getElementById('mainIcon0');
        subIcon.src =
          '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/SR_active.svg';
      } else if (menuTitle == 'Pending Transactions') {
        var subIcon = <HTMLImageElement>document.getElementById('mainIcon1');
        subIcon.src =
          '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/transaction_active.svg';
      } else if (menuTitle == 'Transaction History') {
        var subIcon = <HTMLImageElement>document.getElementById('mainIcon2');
        subIcon.src =
          '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/history_active.svg';
      }
      /*else if(menuTitle == "Change Password")
              {
                var subIcon = <HTMLImageElement>document.getElementById('mainIcon3');
                subIcon.src = '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/resetPass_active.svg';
            
              }*/
    }
  }
}
